import React from 'react'
import { connect } from 'react-redux'

import './loading.css'
import { 
    LoadingOutlined
    } from '@ant-design/icons'
const mapStateToProps=(state)=>{
    return{
        showLoading:state.showLoading
    }
}

const Loading = (props) => {
    
    return (
        <>
            {
            props.showLoading?(
                <div className='loadMain' >
                    <div className='loadMain1'>
                        <img alt='loading'  className="loadingIcon" src={require('../../assets/icon/loading.png')}></img>
                        {/* <LoadingOutlined style={{"fontSize":"30px"}}/> */}
                        LOADING
                    </div>
                </div>
            ):null
            }
        </>
        
        
    );
}

export default connect(mapStateToProps)(Loading);
